export default __webpack_public_path__ + "static/media/ctg-4b.51495fa2.webp";